import Vue from 'vue'
import clipboard from 'clipboard'

Vue.prototype.clipboard = clipboard;
